import { createSelector } from '@reduxjs/toolkit';
import {
  employeesShortNamesAndI,
  eventOccurrencesNotDeleted,
  functionsNotDeleted,
  getContactsAsUsers,
  type NameEntry,
  type PartnerContactAsUser,
} from 'src/store/selectors';
import type { ListSectionItemInput } from 'src/library/lists/listSectionItemInput';
import { dateTimeDisplayShort } from 'src/store/utilities';
import { eventAssigneesText } from 'src/store/eventAssigneesText';
import type { EventOccurrenceViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';

export function eventToListItem(
  event: EventOccurrenceViewModel,
  functions: FunctionViewModel[],
  shortNamesAndI: NameEntry[],
  contactsAsUsers: PartnerContactAsUser[],
): ListSectionItemInput {
  return {
    accessible: true,
    mainIcon: event.doneDate ? 'checkBlue' : undefined,
    label: event.date ? dateTimeDisplayShort(event.date, event.time) + ' ' + event.name : event.name,
    rightLabel: eventAssigneesText(event, functions, shortNamesAndI, contactsAsUsers),
    rightLabelClass: 'assignee',
    clickData: event.uuid,
    href: '/eventOccurrences/' + event.uuid,
  };
}

export const availableEventsAsListItems = createSelector(
  eventOccurrencesNotDeleted,
  functionsNotDeleted,
  employeesShortNamesAndI,
  getContactsAsUsers,
  function (
    events: EventOccurrenceViewModel[],
    functions: FunctionViewModel[],
    shortNamesAndI: NameEntry[],
    contactsAsUsers: PartnerContactAsUser[],
  ): ListSectionItemInput[] {
    return events.map((item) => {
      return eventToListItem(item, functions, shortNamesAndI, contactsAsUsers);
    });
  },
);
